import { ArrowIcon, Box, Button } from '@modusign/design-system';
import { useIsMutating } from 'react-query';
import { useHistory } from 'react-router';

import TemplateSaveButton from './TemplateSaveButton';

interface TemplateEditSaveFooterProps {
  backButtonText: string;
  error: boolean;
  editTemplatePermission?: boolean;
  onBackStepClick: () => void;
  onSaveAsCopyClick: () => void;
  onSaveClick: () => void;
}

function TemplateEditSaveFooter({
  backButtonText,
  error,
  editTemplatePermission,
  onBackStepClick,
  onSaveAsCopyClick,
  onSaveClick,
}: TemplateEditSaveFooterProps) {
  const history = useHistory();

  const isUploadingRequesterAttachments =
    useIsMutating({
      exact: true,
      mutationKey: 'requesterAttachmentUpload',
    }) > 0;

  return (
    <Box
      backgroundColor="darkGray700"
      bottom={0}
      color="white"
      left={0}
      pt={4}
      px="25px"
      sx={{
        whiteSpace: 'nowrap',
        zIndex: 500, // $z-index-fixed-layout
      }}
      width="100%"
    >
      <Box mb={4} sx={{ minHeight: '38px' }} textAlign="center">
        <Button
          backgroundColor="darkGray500"
          color="lightGray800"
          height="48px"
          mr={2}
          sx={{
            borderColor: 'darkGray500',
            '&:hover': {
              backgroundColor: 'darkGray400',
            },
          }}
          width="180px"
          onClick={onBackStepClick}
        >
          <ArrowIcon direction="left" mr="5px" />
          {backButtonText}
        </Button>
        <Box display="inline-block" position="relative" width="180px">
          {editTemplatePermission ? (
            <TemplateSaveButton
              error={error}
              isLoading={isUploadingRequesterAttachments}
              onSaveAsCopyClick={onSaveAsCopyClick}
              onSaveClick={onSaveClick}
            />
          ) : (
            <Button
              backgroundColor="darkGray500"
              color="lightGray800"
              height="48px"
              sx={{
                borderColor: 'darkGray500',
                '&:hover': {
                  backgroundColor: 'darkGray400',
                },
              }}
              width="180px"
              onClick={() => {
                history.push('/templates');
              }}
            >
              나가기
              <ArrowIcon direction="right" ml="5px" />
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default TemplateEditSaveFooter;
